//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Options.js";
import "../no/TransientObject.js";
let d=[[[0,"CurrentLevel",0,0]],[[["name","value"],"SetValue",{},2,0],[["name","value"],"SetRealValue",{},2,0],[["name","value"],"SetStringValue",{},2,0],[["name","value"],"SetUtf8Value",{},2,0],[["name","value"],"SetStringListValue",{},2,0],[["name","value"],"SetValueOrder",{},2,0],[["name","selection","value"],"SetValueSelection",{},3,0],[["name","value"],"SetLogicalValue",{},2,0],[["name","comment"],"SetUserComment",{},2,0],[["name"],"LockValue",{},1,0],[["name"],"UnlockValue",{},1,0],[[],"Save",{},0,0],[[],"Dispose",{},0,0],[[],"Load",{},0,0]],[]];
SPLM.Options.DraftingStandardChangeList = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Options.DraftingStandardChangeList";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;